<template>
<div class="swiper-container">
    <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
        <!--SLIDE-1-->
        <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Actividad de conocimientos previos">
            <div class="container-fluid">
                <div class="row" id="slide-1">
                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 pr-lg-5">
                        <div class="mt-3 mt-lg-5 p-3 pl-lg-5 mt-5 mb-lg-5 mb-0">
                            <h2 class="mt-5">Actividad de conocimientos previos</h2>
                            <h3>Describiendo al sujeto sordo según Piaget</h3>
                            <h5>Tipo de actividad: tarea</h5>
                            <h4 class="mt-5 color1 font-weight-bold">Objetivo</h4>
                            <p>Identificar conocimientos previos sobre el desarrollo cognitivo del sujeto sordo desde los aportes y teorías de Piaget.</p>
                            <h4 class="mt-5 color1 font-weight-bold">¿Qué hacer?</h4>
                            <p class="mb-0 pb-0">En el siguiente video de YouTube se aborda la temática principal de esta unidad en unos pocos minutos.</p>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-CP d-flex justify-lg-content-center align-items-lg-center">
                        <div class="row">
                            <div class="col-xl-10 col-lg-12 col-md-12 col-12 offset-xl-1 mb-5">
                                <div class="bg-white p-4 sombraActividades">
                                    <h4 class="text-center">Video</h4>

                                    <p class="txtfiguras mt-2 text-center">Ayuso, C., Tavira, M., Ambrosio, M., Arias, N., Serrano, N. y Sánchez, H. [Clau Vans]. (10 de noviembre de 2016). Etapas del desarrollo cognitivo de Piaget (MUY BIEN EXPLICADO CON DIBUJOS) [archivo de video]. Recuperado de <span class="url text-white"><a href="https://www.youtube.com/watch?v=y8fh2e5O2UY" target="_blank">https://www.youtube.com</a></span> </p>
                                    <ol>
                                        <li>
                                            <p class="mb-0 pb-0">Observe el video.</p>
                                        </li>
                                        <li>
                                            <p class="mb-0 pb-0">Analice la información.</p>
                                        </li>
                                        <li>
                                            <p class="mb-0 pb-0">Escriba en una página un texto tipo ensayo de opinión (fuente Times New Roman, tamaño 12 e interlineado 1.5) lo que comprendió sobre la temática plasmada en el video.</p>
                                        </li>

                                        <li>
                                            <p>Haga clic en el botón <i>Subir tarea</i> para entregar el ensayo.</p>
                                        </li>

                                    </ol>

                                    <button class="btn BtnPrincipal d-flex mx-auto mt-3 mb-3" onClick="javascript:window.open('http://campusvirtual.itm.edu.co/mod/assign/view.php?id=204365&forceview=1', '_blank');">Subir tarea</button>
                                </div>
                                <p class="text-right text-white url mt-2 d-none d-lg-block d-md-none">Foto por <a href="https://www.freepik.es/" target="_blank" class="text-white" rel="noopener noreferrer">Freepik</a> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--SLIDE-1-->
    </div>
</div>
</template>

<script>
import {
    SwiperController
} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'Actividad de conocimientos previos',

    mounted() {
        SwiperController(),
            document.title = this.$route.meta.title
    }
}
</script>
